export default __webpack_public_path__ + "d25be40.png";